import db, { storage } from './firebase';
import { v4 as uuidv4 } from 'uuid';

export const createProductDocument = async (details) => {
    // get the reference to the Firestore document
    const batch = db.batch();
    const uniqueId = uuidv4();
    const docRef = db.collection('Products').doc();

    //create user object
    details.uniqueId = uniqueId;
    details.ProductPostedDateTime = new Date();

    // write to Cloud Firestore
    const collectionRef = await db.collection('Products').doc();
    batch.set(collectionRef, details);
    batch.commit().then(() => {
        return true;
    }).catch((error)=> {
        return false
    });
}

export const getProductDocumentForSupply = async () => {
    // get the reference to the Firestore document
    const snapshot = await db.collection('Products').get()
    return snapshot.docs.map(doc => ({...doc.data(), _id: doc.id}));
}

export const getProductDocumentWithUserId = async (userId) => {
    // get the reference to the Firestore document
    const snapshot = await db.collection('Products').where("userId","==", userId).get()
    return snapshot.docs.map(doc => ({...doc.data(), _id: doc.id}));
}

export const getProductDocumentWithUniqueId = async (uniqueId) => {
    // get the reference to the Firestore document
    const snapshot = await db.collection('Products').where("uniqueId", "==", uniqueId).get()
    return snapshot.docs.map(doc => ({...doc.data(), _id: doc.id}));
}

export const getProductDetails = async (uniqueId) => {
    // get the reference to the Firestore document
    let product = null;
    let retailer = null;
    const productSnapshot = await db.collection('Products').where("uniqueId", "==", uniqueId).get()
    productSnapshot.docs.map(doc => {
        product = doc.data()
    });

    const employerSnapshot = await db.collection('Users').where("uid", "==", product.userId).get()
    employerSnapshot.docs.map(doc => {
        retailer = doc.data()
    });
    return {
        product: product,
        retailer: retailer
    }
}

export const getAllProductDocument = async () => {
    // get the reference to the Firestore document
    const snapshot = await db.collection('Products').get()
    return snapshot.docs.map(doc => ({...doc.data(), _id: doc.id}));
}

export const updateProductDocument = async (product) => {
    const docRef = db.doc(`/Products/${product._id}`);
    return docRef.update(product);
}

export const getAllApplicantCvs = async (employerId) => {
    // get the reference to the Firestore document
    const snapshot = await db.collection('AppliedProducts').where("employerId", "==", employerId).get()
    return snapshot.docs.map(doc => ({...doc.data(), _id: doc.id}));
}

export const getAllAppliedProductsByProductIdAsync = async (productId) => {
    // get the reference to the Firestore document
    let product = null;
    let appliedApplicant = [];
    const appliedApplicantSnapshot = await db.collection('AppliedProducts').where("productId", "==", productId).get()
    appliedApplicantSnapshot.docs.map(doc => {
        appliedApplicant.push(doc.data())
    });

    const productSnapshot = await db.collection('Products').where("uniqueId", "==", productId).get()
    productSnapshot.docs.map(doc => {
        product = doc.data()
    });
    return {
        product: product,
        appliedApplicant: appliedApplicant
    }
}

export const getAllAppliedProductsByUidAsync = async (userId) => {
    // get the reference to the Firestore document
    const snapshot = await db.collection('AppliedProducts').where("userId", "==", userId).get()
    return snapshot.docs.map(doc => ({...doc.data(), _id: doc.id}));
}

export const applyProductAsync = async (details) => {
    // get the reference to the Firestore document
    const uniqueId = uuidv4();
    const docRef = db.doc(`/AppliedProducts/${uniqueId}`);

    //create user object
    details.uniqueId = uniqueId;
    details.productAppliedDateTime = new Date();
    details.createdAt = new Date();

    // write to Cloud Firestore
    await docRef.set(details);
    const getBackAppliedProducts = db.doc(`/AppliedProducts/${uniqueId}`);
    await getBackAppliedProducts.get().then(result => {
        console.info('result',result?.exists)
        if(result?.exists) {
            return true;
        } else {
            return false
        }
    });
}